enum RobustnessLevel {
    HW_SECURE_ALL    = 'HW_SECURE_ALL',
    HW_SECURE_CRYPTO = 'HW_SECURE_CRYPTO',
    HW_SECURE_DECODE = 'HW_SECURE_DECODE',
    SW_SECURE_CRYPTO = 'SW_SECURE_CRYPTO',
    SW_SECURE_DECODE = 'SW_SECURE_DECODE'
}

export default RobustnessLevel;